export class FontScalerComponent {
  
  private static readonly MAX_SCALE = 2
  private static readonly MIN_SCALE = 0.5
  private static readonly STEP = 0.1

  scale: number
  defaultScale: number
  isActive = false

  constructor(defaultScale = 1) {

    const saved = parseFloat(localStorage.getItem('fontSizeFactor') || '')

    this.scale = !isNaN(saved) ? saved : defaultScale
    this.defaultScale = defaultScale
    this.isActive = this.scale !== this.defaultScale
  }

  increase(targetClasses: string | string[]) {

    const newScale = Math.min(this.scale + FontScalerComponent.STEP, FontScalerComponent.MAX_SCALE)

    if (newScale === this.scale) return

    this.scale = newScale
    this.isActive = true
    this.apply(targetClasses)
  }

  decrease(targetClasses: string | string[]) {

    const newScale = Math.max(this.scale - FontScalerComponent.STEP, FontScalerComponent.MIN_SCALE)

    if (newScale === this.scale) return

    this.scale = newScale
    this.isActive = true
    this.apply(targetClasses)
  }
  
  reset(targetClasses: string | string[]) {

    const classes = Array.isArray(targetClasses) ? targetClasses : [targetClasses]

    classes.forEach(className => {

      const elements = document.querySelectorAll(`.${className}`)

      elements.forEach(element => {

        if (!(element instanceof HTMLElement)) return

        if (element.dataset.originalFontSize) {
          element.style.setProperty('font-size', element.dataset.originalFontSize, 'important')
        }

        element.querySelectorAll('*').forEach(child => {
          if (child instanceof HTMLElement && child.dataset.originalFontSize) {
            child.style.setProperty('font-size', child.dataset.originalFontSize, 'important')
          }
        })

      })
    })

    this.scale = this.defaultScale
    this.isActive = false
    localStorage.setItem('fontSizeFactor', this.scale.toString())
  }

  remember(targetClasses: string | string[]) {

    const classes = Array.isArray(targetClasses) ? targetClasses : [targetClasses]

    classes.forEach(className => {

      const elements = document.querySelectorAll(`.${className}`)

      elements.forEach(element => {

        if (!(element instanceof HTMLElement)) return

        if (!element.dataset.originalFontSize) {
          element.dataset.originalFontSize = getComputedStyle(element).fontSize
        }

        element.querySelectorAll('*').forEach(child => {

          if (child instanceof HTMLElement && !child.dataset.originalFontSize) {
            child.dataset.originalFontSize = getComputedStyle(child).fontSize
          }
        })
      })
    })
  }

  apply(targetClasses: string | string[]) {

    const classes = Array.isArray(targetClasses) ? targetClasses : [targetClasses]

    classes.forEach(className => {
      const elements = document.querySelectorAll(`.${className}`)

      elements.forEach(element => {

        if (!(element instanceof HTMLElement)) return

        const parsed = parseFloat(element.dataset.originalFontSize || '')
        const original = isNaN(parsed) ? 0 : parsed
        element.style.setProperty('font-size', `${original * this.scale}px`, 'important')

        element.querySelectorAll('*').forEach(child => {

          if (child instanceof HTMLElement) {
            const parsedChild = parseFloat(child.dataset.originalFontSize || '')
            const childOriginal = isNaN(parsedChild) ? 0 : parsedChild
            child.style.setProperty('font-size', `${childOriginal * this.scale}px`, 'important')
          }
        })
      })
    })

    localStorage.setItem('fontSizeFactor', this.scale.toString())
  }

}
